// extracted by mini-css-extract-plugin
export var button = "Code-module--button--46uGo";
export var bxTextTruncateEnd = "Code-module--bx--text-truncate--end--If7sI";
export var bxTextTruncateFront = "Code-module--bx--text-truncate--front--9rgi1";
export var container = "Code-module--container--0cdnZ";
export var copyButton = "Code-module--copy-button--5xPbK";
export var dark = "Code-module--dark--rdSJ3";
export var highlight = "Code-module--highlight--R27+h";
export var path = "Code-module--path--uA6dr";
export var pathRow = "Code-module--path-row--hRuR3";
export var row = "Code-module--row--Iifgu";
export var showMoreButton = "Code-module--show-more-button--YwEW7";
export var sideBarMinHeight = "Code-module--sideBarMinHeight--GnrQu";
export var sidebar = "Code-module--sidebar--fc4E6";